/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import { AST } from './ast.js';


const PARAMTYPE_INT = 1;
const PARAMTYPE_DATE = 2;


export default class VM {
  constructor() {
    this.stack = [];
  }


  static get PARAMTYPE_INT() {
    return PARAMTYPE_INT;
  }

  static get PARAMTYPE_DATE() {
    return PARAMTYPE_DATE;
  }


  evaluateAllExpressions(symbols) {
    var num_exprs = symbols.allNames.length;

    for (var i = 0; i < num_exprs; i++) {
      var name = symbols.allNames[i];
      var sym = symbols[name];

      sym.value = this.evaluateExpression(symbols, sym.expr);
    }
  }


  evaluateExpression(symbols, expr) {
    var date = new Date(1900, 1, 1);

    try {
      this.evalExpression( symbols, expr );
      if (this.stack.length === 1) {
        date = this.popValue();
      }
      else {
        throw "Stack Error";
      }
    }
    catch (err) {
      console.log("RUNTIME ERROR: " + err);
    }

    return date;
  }


  evalExpression( symbols, expr ) {
    if (expr.nodeType === AST.NODETYPE_DATE) {
      this.pushDate(expr.dateVal);
    }
    else if (expr.nodeType === AST.NODETYPE_NUMBER) {
      this.pushNumber(expr.numVal);
    }
    else if (expr.nodeType === AST.NODETYPE_IDENT) {
      if ( expr.ident in symbols) {
        var sym = symbols[expr.ident];
        this.pushDate(sym.value); 
      }
      else {
        var param = this.getParam(symbols,expr.ident);

        if (param === null) {
          throw "Unknown Identifier " + expr.ident;
        }
        this.evalParam(param);
      }
    }
    else if (expr.nodeType === AST.NODETYPE_FUNCTION) {
      var num_params = expr.params.length;
      for (var i = 0; i < num_params; i++) {
        this.evalExpression(symbols, expr.params[i]);
      }

      this.execFunction(expr.funcName);
    }
    else {
      throw "Unknown Type " + expr.nodeType;
    }
  }


  getParam(symbols,name) {
    var param = null;
    var lower = name.toLowerCase();
    var num_params = symbols.params.length;

    for ( let i = 0; i < num_params; i++) {
      param = symbols.params[i];

      if (lower === param.name ) {
        return param;
      }
    }

    return null;
  }


  // Same function is in model manager
  evalParam(param) {
    if (param.type === PARAMTYPE_DATE ) {
      this.pushDate( param.adjustedValue );
    }
    else if (param.type === PARAMTYPE_INT ) {
      this.pushNumber( param.adjustedValue );
    }
    else {
      throw "Unknown Param Type " + param.paramType;
    }
  }


  execFunction(name) {
    var func = name.toLowerCase();

    if (func === "today") {
      this.pushDate(new Date());
    }
    else if (func === "endafter") {
      var months = this.popValue();
      var years = this.popValue();
      var origin = new Date( this.popValue() );

      var total_months = ( 12 * years + months ) - 1;

      var d = new Date( origin.setMonth( origin.getMonth()+ total_months ) );
      this.pushDate(d);
    }
    else if (func === "startofprimary") {
      var origin = this.popValue();

      this.pushDate(new Date());
    }
    else if (func === "endofschool") {
      var origin = this.popValue();

      this.pushDate(new Date());
    }
    else {
      console.log(func);
    }

    //console.log(name);
  }


  pushDate(date) {
    //console.log("push date: " + date);
    this.stack.push(date);
  }


  pushNumber(num) {
    //console.log("push num: " + num);
    this.stack.push(num);
  }


  pushString(string) {
    this.stack.push(string);
  }


  popValue() {
    return this.stack.pop();
  }

}


